"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _default = function _default(_ref) {
  var itemThumbnail = _ref.itemThumbnail,
      itemPrice = _ref.itemPrice,
      itemTitle = _ref.itemTitle,
      itemDescription = _ref.itemDescription,
      itemNote = _ref.itemNote,
      itemLabels = _ref.itemLabels,
      itemCTALink = _ref.itemCTALink;
  return _react["default"].createElement(_semanticUiReact.Item.Group, null, _react["default"].createElement(_semanticUiReact.Item, null, itemThumbnail && _react["default"].createElement(_semanticUiReact.Item.Image, {
    size: "small",
    src: itemThumbnail
  }), _react["default"].createElement(_semanticUiReact.Item.Content, null, _react["default"].createElement(_semanticUiReact.Item.Header, null, itemTitle), itemPrice && _react["default"].createElement(_semanticUiReact.Item.Meta, null, itemPrice), itemDescription && _react["default"].createElement(_semanticUiReact.Item.Description, null, itemDescription), _react["default"].createElement(_semanticUiReact.Item.Extra, null, itemNote && _react["default"].createElement("div", null, itemNote), itemLabels && itemLabels.map(function (label) {
    return _react["default"].createElement(_semanticUiReact.Label, {
      key: label,
      size: "tiny"
    }, label);
  }), itemCTALink && _react["default"].createElement(_semanticUiReact.Button, {
    as: "a",
    target: "_blank",
    href: itemCTALink,
    primary: true,
    floated: "right"
  }, "Order Now")))));
};

exports["default"] = _default;